// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.entity-property-table {
    table-layout: fixed;
}
.property-name-area {
    width: 30%;
}
.property-action-area {
    width: 2.375rem;
}
.file-action-area {
    width: 5.375rem;
}
tr.dummy {
    display: none;
}
.form-entity input,
.form-entity textarea.property-value {
    font-family: var(--graphileon-font-family-code);
}
.form-entity input::placeholder{
    color: var(--bs-gray-200);
}
.form-entity .CodeMirror .CodeMirror-placeholder {
    color: var(--bs-gray-200);
}
.form-entity .CodeMirror .CodeMirror-lines {
    padding: 0;
}
.form-entity .CodeMirror .CodeMirror-line {
    line-height: 1.5;
    padding: 0;
}

.EntityFormViewRenderer .tab.ui-tabs-active a {
    color: var(--bs-black);
}
.EntityFormViewRenderer .tab a {
    color: var(--bs-gray-300);
}

.form-warning {
    border: var(--bs-border-width) var(--bs-border-style) var(--bs-danger);
    border-radius: var(--bs-border-radius);
}

.typed-entity .type-property,
.typed-entity .type-property input,
.typed-entity .type-property .CodeMirror{
    font-weight: bold;
}

.hidden {
	display: none !important;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
